import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Référentiel } from '../models/référentiel.model';
import { avecMéthodesRéférentiels } from './referentiel.methods';
import { avecSélecteursRéférentiels } from './referentiel.selectors';
import { initialState, ReferentielState } from './referentiel.state';
import { withPagination } from '@shared/store/pagination.feature';
import { withSelectedEntity } from '@shared/store/selected-entity.feature';

export const ReferentielStore = signalStore(
  { providedIn: 'root' },
  withEntities<Référentiel>(),
  withState<ReferentielState>(initialState),
  withSelectedEntity(),
  withPagination<Référentiel>(),
  avecSélecteursRéférentiels(),
  avecMéthodesRéférentiels(),
);
